import * as z from "zod";

export const getTiktokAuthorizationExpiration = {
  name: "getTiktokAuthorizationExpiration" as const,
  input: z.object({}),
  output: z.object({ refreshTokenExpiresAt: z.date().nullish() }),
};
